import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CroppedImage } from './CroppedImage';
import { CREATE_SUB, CREATE_TITLE, productShots } from '../data/resinContent';
export function ProductCarouselSection() {
  const trackRef = useRef<HTMLUListElement>(null);
  const scroll = (dir: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector('li');
    const step = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    track.scrollBy({
      left: dir * step,
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="create-title" data-id="element-266" data-mp="xdd8stk2rhb0">
      <div className="mx-auto max-w-6xl px-5" data-id="element-267" data-mp="sfk5c8a5p1ef">
        <h2 id="create-title" className="text-center font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.5rem]" data-id="element-268" data-mp="ses9qxgk73o5">
          {CREATE_TITLE}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[14px] leading-snug text-body sm:text-[15px]" data-id="element-269" data-mp="1l1wf53jkdk0g">
          {CREATE_SUB}
        </p>
      </div>

      <ul ref={trackRef} className="no-scrollbar mt-8 flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-px-5 px-5 pb-1 lg:mx-auto lg:max-w-6xl" aria-label="Finished resin products" data-id="element-270" data-mp="kw05nl6nblj7">
        {productShots.map(shot => <li key={shot.label} className="w-[76%] shrink-0 snap-start sm:w-[42%] lg:w-[23.5%]" data-id="element-271" data-mp="3tdd3zv2a7g45">
            <figure data-id="element-272" data-mp="26k3ktfbbl0o">
              <CroppedImage image={shot.image} className="w-full bg-charcoal-800" data-id="element-273" data-mp="2728eeg1j7k7" />
              <figcaption className="mt-3 text-center text-[11px] font-semibold uppercase tracking-[0.22em] text-ivory-100" data-id="element-274" data-mp="3kcorj4sjdntd">
                {shot.label}
              </figcaption>
            </figure>
          </li>)}
      </ul>

      <div className="mt-6 flex items-center justify-center gap-3" data-id="element-275" data-mp="1imd7fbxdzgs8">
        <button type="button" onClick={() => scroll(-1)} className="flex h-11 w-11 items-center justify-center rounded-full border border-champagne/40 text-champagne transition-colors duration-150 ease-out hover:bg-champagne hover:text-charcoal-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-champagne" data-id="element-276" data-mp="1nkoh9mnolrag">
          <ChevronLeftIcon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-277" data-mp="1768i69x7xgkg" />
          <span className="sr-only" data-id="element-278" data-mp="24t7lh3if1mrb">Previous products</span>
        </button>
        <p className="text-[10px] font-medium uppercase tracking-[0.2em] text-muted sm:hidden" data-id="element-279" data-mp="24vk3fgo6bx4d">Swipe</p>
        <button type="button" onClick={() => scroll(1)} className="flex h-11 w-11 items-center justify-center rounded-full border border-champagne/40 text-champagne transition-colors duration-150 ease-out hover:bg-champagne hover:text-charcoal-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-champagne" data-id="element-280" data-mp="1zwqlnc1utjye">
          <ChevronRightIcon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-281" data-mp="2irfdcx0lhxvm" />
          <span className="sr-only" data-id="element-282" data-mp="2q67w7hui1z10">Next products</span>
        </button>
      </div>
    </section>;
}